import { Button } from '@mui/material';
import { useRef, useState } from 'react';

interface Props {
  onFileChange: (files) => void;
}

function VNUploadWidget({ onFileChange }: Props) {
  const fileInput = useRef<HTMLInputElement | null>(null);
  const [hover, setHover] = useState(false);

  const processFileChange = (fileList: FileList) => {
    onFileChange(fileList);
  };

  const onBrowseButtonClick = () => {
    // `current` points to the mounted file input element
    if (fileInput && fileInput.current) {
      fileInput.current.click();
    }
  };

  // event handlers
  const onDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setHover(true);
  };
  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setHover(true);
  };

  const onDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setHover(true);
  };
  const onDragEnd = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setHover(false);
  };
  const onFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setHover(false);
    const { files } = event.dataTransfer;
    processFileChange(files);
  };

  return (
    <div
      id="vn-ingest-widget"
      className="vn-upload-widget"
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragEnd={onDragEnd}
      onDrop={onFileDrop}
    >
      <form encType="multipart/form-data">
        <div className="ingest-drop">
          {/* <span className="fa fa-cloud-upload"></span> */}
          <i className="icon material-icons">backup</i>
          <p>Drag and Drop File here</p>
        </div>
        <p>or</p>
        <p>Choose file to upload</p>
        <div className="file-section">
          <input
            className="file-input"
            type="file"
            id="file"
            ref={fileInput}
            onChange={(e) => processFileChange(e.target.files)}
            multiple
          />
          <Button
            variant="contained"
            style={{
              fontSize: '13px',
              marginTop: '5px',
            }}
            size="small"
            className="browse-button"
            color="success"
            onClick={onBrowseButtonClick}
          >
            BROWSE
          </Button>
        </div>
      </form>
    </div>
  );
}

export default VNUploadWidget;
